<template>
	<div>
		<p>
			Born 1993 <br><br>
			Bogdan Spiridon has over 10 years of experience in software development, systems architecture, cloud computing and
			security. <br><br>
			As the CIO at Loyal Solutions, Bogdan Spiridon is responsible for the IT business and development processes, as
			well as overseeing the people and the engineering activities towards delivering state-of-the-art, scalable,
			secure, and compliant products that support the business objectives. <br><br>
			Bogdan Spiridon has been employed since 2015 and has been a member of the executive management since 2022. <br><br>
			<strong>Education</strong><br>
			Master’s Degree in Computer Science from the University of Copenhagen. <br><br>
			Bachelor’s Degree in Computer Science from Alexandru Ioan Cuza University of Iași.
			<br><br>
			<strong>Other current positions</strong><br>
			None. <br><br>
			<strong>Shareholding in the Company</strong><br>
			Bogdan Spiridon will over a period of 12 months earn the rights for up to 41.250 warrants. 
			The warrants can be exercised in a period from August 2022 up until December 2026. <br><br>
		</p>
	</div>
</template>

<script>
export default {
	name: 'BogdanSDescription',
}
</script>
